import { render, staticRenderFns } from "./hospitalDetail.vue?vue&type=template&id=54c8ddce&scoped=true&"
import script from "./hospitalDetail.vue?vue&type=script&lang=js&"
export * from "./hospitalDetail.vue?vue&type=script&lang=js&"
import style0 from "./hospitalDetail.vue?vue&type=style&index=0&id=54c8ddce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c8ddce",
  null
  
)

export default component.exports